/* eslint-disable camelcase */
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import queryString from 'query-string';
import TrackingPage from '../../trackingpage-container/TrackingPage/TrackingPage';
import { Published } from '../../../constants/trackingPageVersions';

function App({ match, location }) {
  const { trackingPageName } = match.params;
  const { search } = location;
  const {
    shipment_id,
    customer_id,
    tracking_reference,
    custom_reference,
    version,
    metadata_key,
    metadata_value,
    toolbar,
    mobile,
  } = queryString.parse(search);

  return (
    <Switch>
      <Route
        path="/:trackingPageName/preview"
        render={() => (
          <TrackingPage
            trackingPageName={trackingPageName}
            shipmentId={shipment_id}
            customerId={customer_id}
            trackingReference={tracking_reference}
            customReference={custom_reference}
            version={version}
            hideToolbar={toolbar?.toLowerCase() === 'false' || false}
            forceMobile={mobile?.toLowerCase() === 'true' || false}
            isPreview
          />
        )}
      />
      <Route
        render={() => (
          <TrackingPage
            trackingPageName={trackingPageName}
            shipmentId={shipment_id}
            customerId={customer_id}
            trackingReference={tracking_reference}
            customReference={custom_reference}
            metadataKey={metadata_key}
            metadataValue={metadata_value}
            version={Published}
            hideToolbar={toolbar?.toLowerCase() === 'false' || false}
            forceMobile={mobile?.toLowerCase() === 'true' || false}
          />
        )}
      />
    </Switch>
  );
}

export default App;
